import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

const ModalCenter = ({
  title = "Cotización del día",
  subtitle = "Ingresa la cotización del dólar a día de hoy",
  isOpen,
  onClose,
  onClick,
  btnText = "Descargar reporte",
  onlyCurrency,
}) => {
  const [exchangeRate, setExchangeRate] = useState(null);
  const [currency, setCurrency] = useState("1");
  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  const handleInputChange = (e) => {
    setExchangeRate(e.target.value);
  };

  const handleDownload = () => {
    // Pasar el exchangeRate al método onClick
    if (onlyCurrency) {
      onClick({ currency });
    } else {
      onClick({ value: exchangeRate });
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        {/* Fondo oscuro */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-6">
            {/* Animación del panel */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-4"
            >
              <Dialog.Panel className="relative bg-white rounded-lg shadow-lg md:w-[480px] p-10">
                {/* Título */}
                <Dialog.Title
                  as="h2"
                  className="poppins-medium text-[18px] text-center text-[#1F384C] tracking-wide"
                >
                  {title}
                </Dialog.Title>

                {/* Subtítulo */}
                <p className="poppins-regular text-center text-xs text-[#8F99A6] mb-[29px]">
                  {subtitle}
                </p>

                {/* Input con USD */}
                <div className="relative mb-[52px]">
                  {onlyCurrency ? (
                    <select
                      value={currency}
                      onChange={handleCurrencyChange}
                      className="poppins-medium text-xs bg-[#F9FAFB] w-full rounded-md py-4 px-[23px] pr-12 focus:outline-none focus:ring"
                    >
                      <option value="1">PYG</option>
                      <option value="2">USD</option>
                    </select>
                  ) : (
                    <>
                      <input
                        type="text"
                        placeholder="Monto"
                        value={exchangeRate}
                        onChange={handleInputChange}
                        className="poppins-medium text-xs bg-[#F9FAFB] w-full rounded-md py-4 px-[23px] pr-12 focus:outline-none focus:ring"
                      />
                      <span className="poppins-medium text-xs absolute right-3 top-2/4 transform -translate-y-2/4 text-gray-500">
                        USD
                      </span>
                    </>
                  )}
                </div>

                {/* Botón de descarga */}
                <button
                  onClick={handleDownload}
                  className={`bg-[#BE202F] w-full text-white text-xs py-4 px-4 rounded-2xl tracking-wider poppins-medium focus:outline-none`}
                >
                  {btnText}
                </button>

                {/* Botón de cerrar */}
                <button
                  onClick={onClose}
                  className="absolute top-4 right-4 text-[#000000] hover:text-gray-600 focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-8 h-8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalCenter;
